import React from "react";

const Affirm = (props) => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{"affirm"}</title>
      <g fillRule="nonzero" fill="none">
        <path
          d="M3.462 16.755c-.81 0-1.751.388-2.261.79l.467.976c.409-.373 1.07-.689 1.665-.689.567 0 .876.187.876.567 0 .259-.208.388-.596.438C2.15 19.024 1 19.426 1 20.553c0 .89.639 1.436 1.63 1.436.71 0 1.342-.395 1.644-.912v.768h1.32v-3.223c0-1.328-.926-1.867-2.132-1.867Zm-.495 4.2c-.373 0-.56-.18-.56-.48 0-.56.625-.747 1.766-.87.007.747-.502 1.35-1.206 1.35Zm15.083-3.223v-.833h-1.32v4.946h1.413v-2.383c0-1.134.682-1.465 1.163-1.465.187 0 .438.058.603.18l.259-1.307a1.597 1.597 0 0 0-.632-.115c-.725 0-1.184.323-1.486.977Zm8.68-.977c-.747 0-1.307.446-1.601.87-.273-.554-.84-.87-1.53-.87-.746 0-1.263.417-1.507.89V16.9h-1.364v4.946h1.414v-2.548c0-.912.481-1.35.926-1.35.402 0 .776.259.776.933v2.965h1.421v-2.548c0-.926.467-1.35.933-1.35.374 0 .768.273.768.926v2.972h1.415v-3.417c0-1.113-.747-1.673-1.651-1.673Zm-16.139-.222v.366H8.445v-.503c0-.653.373-.84.696-.84.187 0 .43.044.632.158l.438-.997c-.259-.151-.682-.288-1.25-.288-.904 0-1.93.51-1.93 2.111v.366h-.819v1.091h.818v3.848h1.415V17.99h2.146v3.855h1.414V17.99h1.285V16.9h-1.285v-.503c0-.653.374-.84.697-.84.359 0 .632.158.632.158l.437-.997s-.445-.288-1.249-.288c-.897-.007-1.93.503-1.93 2.104Zm3.54.366h1.414v4.946H14.13V16.9Z"
          fill="#060809"
        />
        <path
          d="M22.372 10c-3.82 0-7.222 2.65-8.184 6.06h1.385c.804-2.542 3.54-4.768 6.799-4.768 3.963 0 7.38 3.015 7.38 7.71 0 1.056-.137 2.003-.395 2.843H30.7l.014-.043c.222-.868.33-1.809.33-2.8 0-5.233-3.812-9.002-8.672-9.002"
          fill="#0FA0EA"
        />
      </g>
    </svg>
  );
};

export default Affirm;
